import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';

/**
 * A generic tooltip wrapper that shows a short label when the child element
 * is hovered or receives keyboard focus. Built on React Bootstrap's
 * OverlayTrigger + Tooltip, which handles Popper.js positioning and
 * Escape-key dismissal out of the box (WCAG 2.1 AA 1.4.13).
 *
 * Usage:
 *   <ControlLabelTooltip label="Like post">
 *       <Button aria-label="Like post">...</Button>
 *   </ControlLabelTooltip>
 *
 * The child must be a single React element that can accept a ref.
 */
export default function ControlLabelTooltip({
    label,
    placement = 'top',
    children,
}) {
    return (
        <OverlayTrigger
            placement={placement}
            trigger={['hover', 'focus']}
            overlay={<Tooltip>{label}</Tooltip>}
        >
            {children}
        </OverlayTrigger>
    );
}

ControlLabelTooltip.propTypes = {
    /** Text shown inside the tooltip bubble. */
    label: PropTypes.string.isRequired,
    /** Tooltip placement relative to the child element. */
    placement: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
    /** A single React element that can accept a ref (e.g. a Button). */
    children: PropTypes.element.isRequired,
};
